import ClientModule from '@gqlapp/module-client-react';
import MemberMobile from "./MemberMobile";
import AnonymousMobile from "./menu";
export default new ClientModule(MemberMobile, AnonymousMobile)
